/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'linkedin-round-black': {
    width: 35,
    height: 35,
    viewBox: '0 0 35 35',
    data:
      '<path pid="0" d="M35 17.5C35 27.164 27.165 35 17.5 35S0 27.164 0 17.5C0 7.835 7.835 0 17.5 0S35 7.835 35 17.5zm-19.744-2.805v10.097h3.235v-4.873c0-1.286.258-2.53 1.942-2.53 1.66 0 1.683 1.47 1.683 2.613v4.79h3.236v-5.404c0-2.653-.605-4.693-3.882-4.693-1.576 0-2.633.816-3.065 1.59h-.045v-1.59h-3.104zM9.648 24.792h3.365V14.695H9.648v10.097zm3.365-12.901a1.684 1.684 0 1 0-3.367.001 1.684 1.684 0 0 0 3.367-.001z" _fill="#000" fill-rule="evenodd"/>'
  }
})
